import { Achievements } from '@cardsjd/achievements';
import { Advertisement } from '@cardsjd/advertisement';
import { Analytics } from '@cardsjd/analytics';
import { Device } from '@cardsjd/device';
import { EmailFeedback } from '@cardsjd/emailfeedback';
import { FBInstantGame } from '@cardsjd/fbinstantgame';
import { IAP } from '@cardsjd/iap';
import { Localization } from '@cardsjd/localization';
import { MarketPlace } from '@cardsjd/marketplace';
import { Prompter } from '@cardsjd/prompter';
import { RateApp } from '@cardsjd/rateapp';
import { Share } from '@cardsjd/share';
import { Storage } from '@cardsjd/storage';

import i18n from './services/i18n.js';
import Multiplayer from './services/Multiplayer.js';
import { generateId, getRandomAvatarURL } from './services/utilities.js';

import AchievementConfig from './configs/AchievementConfig.js';
import AdvertisementConfig from './configs/AdvertisementConfig.js';
import AppConfig from './configs/AppConfig.js';
import LocalizationConfig from './configs/LocalizationConfig.js';
import StoreConfig from './configs/StoreConfig.js';

export default class App {

	constructor() {
		this.userdata = {};
		this.config = AppConfig;
		this.pageId = 'Loading';
		this.onNavigate = function (_path) { };

		this.onNotification = function (_model) { };

		this.onPopUp = function (_model, _template) { };

		this.debug = this.config.debug;
		this.version = this.config.version;

		//libraries
		this.device = new Device();
		this.localization = new Localization(LocalizationConfig);
		this.marketPlace = new MarketPlace(AppConfig);
		this.rateApp = new RateApp(AppConfig);
		this.emailFeedback = new EmailFeedback(AppConfig);
		this.sharer = new Share(AppConfig);
		this.analytics = new Analytics(AppConfig);
		this.achievements = new Achievements(AchievementConfig);
		this.achievements.onNewAchievement = this.onNewAchievement.bind(this);
		this.prompter = new Prompter(AppConfig);
		this.prompter.onPrompt = this.onPrompt.bind(this);
		this.storage = new Storage(AppConfig);
		this.FBInstantGame = new FBInstantGame();
		this.advertisement = new Advertisement(AdvertisementConfig);
		this.iap = new IAP(StoreConfig);

		//get default resource
		this.resource = this.localization.getResource();

		//get device info
		this.device.onBackButton = this.onBackButton.bind(this);
		this.os = this.device.getOS();
		this.platform = this.device.getPlatform();
		this.browser = this.device.getBrowser();

		;
		this.iap.onBuy = this.onBuy.bind(this);

		this.multiplayer = new Multiplayer(AppConfig);
		console.log('multiplayer class is', this.multiplayer);
	}

	async load() {
		this.navigate('Loading');

		//load userdata
		const data = await this.storage.load('gin.userdata');
		if (data) {
			this.userdata = data;
		}

		//facebook init and load data
		await this.loadFacebookData();

		//set localization resource based on user settings
		if (this.userdata.language) {
			this.resource = this.localization.getResource(this.userdata.language);
		}

		//tracking
		this.analytics.trackStart();
		//todo: firebase track user

		//ask to rate / share
		this.prompter.delayedPrompt();

		//save os in profile
		this.userdata.os = this.device.getOS();
		this.userdata.platform = this.device.getPlatform();
		this.userdata.browser = this.device.getBrowser();
		this.userdata.version = this.version;

		//log game opened
		this.userdata.game_open = (this.userdata.game_open || 0) + 1;
		this.userdata.last_open = Date.now();
		if (!this.userdata.first_open) {
			this.userdata.first_open = Date.now();
		}

		if (!this.userdata.name) {
			this.userdata.name = `Player ${generateId()}`;
		}

		if (!this.userdata.avatar) {
			this.userdata.avatar = getRandomAvatarURL();
		}

		//check for achievements
		this.achievements.checkForAchievementAndReward(this.userdata, this.userdata);

		this.iap.init().catch(e => console.log('IAP.init() failed', e));

		//todo: Push Notifications

		//todo:black list check

		//set up ads
		//todo: requestTrackingAuthorizationWithExplainer() with explainer text;
		this.advertisement.setUp();

		////Proxy could be used to trigger save on data change or UI refresh.  Turned off for now to reduce complexity and increase performance.
		// const proxyHandler = {
		// 	set: (obj, prop, value) => {
		// 		const isDifferent = obj[prop] !== value;
		// 		const success = Reflect.set(obj, prop, value);

		// 		if (success && isDifferent) {
		// 			this.handleDataChange(obj);
		// 		}

		// 		return success;
		// 	},
		// };

		// this.userdata = new Proxy({
		// 	...this.userdata,
		// }, proxyHandler);
		////

		this.navigate('MainMenu');
	}
	refreshUI() {
		//trigger UI contollers
		console.log('refreshUI called - userdata:', {
			removeAds: this.userdata.removeAds,
			fullVersion: this.userdata.fullVersion
		});
		if (this.onRefreshUI) {
			this.onRefreshUI();
		}
	}
	navigate(path) {
		this.pageId = path;

		//trigger UI contollers
		if (this.onNavigate) {
			this.onNavigate(path);
		}

		this.navigated(path);
	}

	navigated(path) {
		if (path === '') {
			path = 'MainMenu';
		}

		console.log('navigated', path);

		//todo: firebase track page;

		if (path === 'MainMenu') {
			this.showAd();
			this.save();
		}

		if (path === 'ComputerMenu') {
			this.showAd();
			this.save();
		}

		if (path === 'OnlineMenu') {
			this.showAd();
			this.save();
		}
	}
	onBackButton() {
		//check for any popups
		const dialogBoxs = document.querySelectorAll(".dialogBox");
		for (let i = 0; i < dialogBoxs.length; i++) {
			let dialogBox = dialogBoxs[i];
			if (dialogBox && dialogBox.style && dialogBox.style.display != "none" && dialogBox.style.display != "") {
				dialogBox.style.display = "none";
				return;
			}
		}

		//exit app
		if (this.page === "MainMenu") {
			this.device.exitApp();
		} else {
			this.navigate("/");
		}

	}
	onNewAchievement(achievements) {
		//this.showAchievementPopup(achievements);
		this.save();
		for (let i = 0; i < achievements.length; i++) {
			const achievement = achievements[i];
			this.showNotification({
				title: achievement.title,
				description: achievement.description,
				image: achievement.image,
				points: achievement.points,
				type: 'Achievement',
			});
		}
		//update UI
		this.refreshUI();
	}

	save() {
		this.storage.save('gin.userdata', this.userdata);
		this.FBInstantGame.saveData(this.userdata);
	}

	showAd(force) {
		if (force) {
			this.advertisement.showInterstitialAd();
		}

		if (this.fullVersion || this.userdata.removeAds) {
			this.advertisement.removeAds = true;
			return;
		}

		this.advertisement.tryShowInterstitialAd();
	}

	showRewardAd() {
		this.advertisement.showRewardedAd();
	}

	rateGame() {
		this.achievements.awardAchivement(this.userdata, 'Rate Game');
		const results = this.rateApp.rate();
		if (!results) {
			this.share();
		}
	}

	email() {
		this.achievements.awardAchivement(this.userdata, 'Send Feedback');
		this.emailFeedback.send(this.userdata);
	}

	share() {
		this.achievements.awardAchivement(this.userdata, 'Share Game');
		this.sharer.share();
	}

	delay(n) {
		return new Promise(function (resolve) {
			setTimeout(resolve, n * 1000);
		});
	}

	showNotification(model) {
		//Basic - { message: "Message", type: "Basic" }
		//Achievement - { message: "Test", description: "Something more", points: 25, type:"Achievement" }
		if (typeof model === 'string') {
			model = {
				message: model,
				type: 'Basic',
			};
		}

		if (this.onNotification) {
			this.onNotification(model);
		}
	}

	showPopUp(model, template) {
		if (this.onPopUp) {
			this.onPopUp(model, template);
		}
	}

	showEnjoyGame(message) {
		if (!message) {
			message = i18n.t('Having fun?');
		}

		this.showPopUp({
			message: message,
			onYes: this.showAskRate.bind(this),
		}, 'YesNoDialog');
	}

	showShare(message) {
		if (!message) {
			message = i18n.t('Share the app?');
		}

		this.showPopUp({
			message: message,
			onYes: this.share.bind(this),
		}, 'YesNoDialog');
	}

	showAskRate(message) {
		if (!message) {
			message = i18n.t('Rate the app?');
		}

		this.showPopUp({
			message: message,
			onYes: this.rateGame.bind(this),
		}, 'YesNoDialog');
	}

	onPrompt(message, os) {
		if (os === 'FBMessenger') {
			this.showShare(message);
		} else {
			//ask if like game then ask to rate
			this.showEnjoyGame(message);
		}

		this.rateApp.rateNative();
	}

	setIsMuted(isMuted) {
		this.userdata.isMuted = isMuted;
		this.save();
		this.refreshUI();
	}


	onBuy(productId) {

		if (productId.indexOf('removeads') > -1) {
			if (!this.userdata.removeAds) {
				this.showNotification('Ads have been removed');
			}
			console.log('Ads removed via IAP');
			this.userdata.removeAds = true;
		}
		if (productId.indexOf('fullVersion') > -1) {
			if (!this.userdata.fullVersion) {
				this.showNotification('Full version unlocked');
			}

			this.userdata.fullVersion = true;
		}

		//trigger ui refresh
		this.refreshUI();
		this.save();
	}

	setLanguage(newLanguage) {
		this.userdata.language = newLanguage;
		this.save();
	}
	resetStats() {
		this.userdata.stats = {};

		this.save();
	}
	resetData() {
		this.userdata = {};
		this.showNotification('All data has been reset');
		this.save();
	}
	async loadFacebookData() {
		if (!this.FBInstantGame.isOnFacebook) {
			return;
		}

		await this.FBInstantGame.initialize();

		//load fb user data if no local data
		if (!this.userdata || JSON.stringify(this.userdata) === '{}') {
			const fbUserData = await this.FBInstantGame.loadData('userdata');
			if (fbUserData) {
				this.userdata = fbUserData;
			}
		}

		//load fb profile data
		const fbProfile = await this.FBInstantGame.getProfile();
		if (fbProfile) {
			if (fbProfile.id) {
				this.userdata.facebookId = fbProfile.id;
			}

			if (!this.userdata.name && fbProfile.name) {
				this.userdata.name = fbProfile.name;
			}

			//update avatar if not set or if it is a facebook avatar.  Facebook avatars expire and the user will be left with a broken image
			//todo: push avatar to JD image server and use that instead
			const isFacebookAvatar = typeof this.userdata.avatar == "string" && this.userdata.avatar.includes('fbsbx');
			if ((!this.userdata.avatar || isFacebookAvatar) && fbProfile.pic) {
				this.userdata.avatar = fbProfile.pic;
			}

			if (fbProfile.pic) {
				this.userdata.avatar_facebook = fbProfile.pic;
			}

			if (!this.userdata.locale && fbProfile.locale) {
				this.userdata.locale = fbProfile.locale;
			}
		}

		//check for invites
		const invite = await this.FBInstantGame.getInvite();
		if (invite) {
			this.showNotification(i18n.t('You have been invited to play a game'));
		}
	}
	get showMoreGames() {
		return this.config.showMoreGames && this.platform !== 'FBInstant' && this.marketPlace.hasGames() && !this.userdata.fullVersion;
	}
	get showAbout() {
		return this.config.showAbout;
	}
	get showRemoveAds() {
		return !this.userdata.removeAds && this.iap?.isAvailable && !this.userdata.fullVersion;
		//show remove ads for only android native, until other platforms are implemented
		// //return this.platform === 'android' && !this.userdata.removeAds && this.iap?.isAvailable && !this.userdata.fullVersion;
	}
	get showSendEmail() {
		return this.platform !== 'FBInstant';
	}
	get showRateGame() {
		return this.platform !== 'FBInstant';
	}

	get showSendFeedback() {
		return this.platform !== 'FBInstant';
	}

}
